'use client';

import type { FC } from 'react';
import { ItemListItemSkeleton } from './ItemListItemSkeleton';
import { cn } from '../utils/cn';

interface ItemGridSkeletonProps {
  count?: number;
  className?: string;
  minColumn?: number;
  cardClassName?: string;
}

export const ItemGridSkeleton: FC<ItemGridSkeletonProps> = ({ count = 16, className, minColumn = 160, cardClassName }) => (
  <div
    className={cn('grid items-start gap-1 pt-2', className)}
    style={{ gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${minColumn}px), 1fr))` }}
  >
    {Array.from({ length: count }).map((_, i) => (
      <ItemListItemSkeleton key={i} className={cardClassName} />
    ))}
  </div>
);
